export default __webpack_public_path__ + "static/media/photosAdultLeft.4a946387.webp";